import withAdminLayout from "highline/layouts/with_admin_layout"
import AdminCategoriesIndexContainer from "highline/containers/admin/categories/index_container"

const CategoriesIndex = (props) => (
  <AdminCategoriesIndexContainer { ...props } />
)

export default withAdminLayout(CategoriesIndex)
